<mat-expansion-panel class="card-panel" [expanded]="true" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <i class="material-icons" (click)="downloadImage($event)">
        save
      </i>      {{('dashboard.' + name) | translate}}
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="panel-content">
    @if (data) {
      <div>
        <mat-slide-toggle
          style="float: right"
          class="example-margin"
          [(ngModel)]="checked">
          <i class="material-icons">
            bar_chart
          </i>
        </mat-slide-toggle>
        @if (systemTyp) {
          <mat-slide-toggle
            matTooltip="nur zukünftige Events berücksichtig"
            style="float: right"
            class="example-margin"
            [(ngModel)]="isTime"
            (change)="changeTime()">
            <i class="material-icons">
              today
            </i>
          </mat-slide-toggle>
        }
        <div class="pie-double-info"  #screen>
          @if (!checked && data.length) {
            <ngx-charts-tree-map
              [view]="view"
              [scheme]="colorScheme ? colorScheme : 'ocean'"
              [customColors]="colorScheme"
              [results]="data"
              [gradient]="true"
              [animations]="true">
            </ngx-charts-tree-map>
          }
          @if (checked && data.length) {
            <ngx-charts-bar-vertical
              class="chart-container"
              [view]="view"
              [scheme]="colorScheme ? colorScheme : 'ocean'"
              [customColors]="colorScheme"
              [results]="data"
              [animations]="true"
              [gradient]="true"
              [xAxis]="true"
              [yAxis]="true"
              [showDataLabel]="true"
              [legend]="true">
            </ngx-charts-bar-vertical>
          }
          @if (!data.length) {
            <p class="no-data-msg-chart">No Data</p>
          }
        </div>
      </div>
    }

  </div>
</mat-expansion-panel>


<div [hidden]="true" id="download">
  <img #canvas>
  <a #downloadLink></a>
</div>

